// import { Button } from "nq-component";
// import { CURRENCY_FORMATTER } from "../utils/constants";

// const SummaryItem = ({ label, value, aggregatedData }) => (
//   <h5 className="mt-1" style={{ fontSize: "12px" }}>
//     <span className="fw-bold">{label}:</span>{" "}
//     {aggregatedData && Object.keys(aggregatedData).length > 0
//       ? CURRENCY_FORMATTER.format(value)
//       : "Processing..."}
//   </h5>
// );

// const ReportSummary = ({
//   totals,
//   voidTotals,
//   aggregatedData,
//   store,
//   exportCSV,
// }) => {
//   return (
//     <div
//       className="p-4"
//       style={{
//         backgroundImage: `url('/green.png')`,
//         borderRadius: "0 0 20px 20px",
//         height: "325px",
//       }}
//     >
//       <div className="card p-2" style={{ opacity: ".7" }}>
//         <SummaryItem
//           label="TOTAL NET SALES"
//           value={totals.net}
//           aggregatedData={aggregatedData}
//           store={store}
//         />
//         <SummaryItem
//           label="TOTAL GROSS SALES"
//           value={totals.gross}
//           aggregatedData={aggregatedData}
//           store={store}
//         />
//         <SummaryItem
//           label="TOTAL PRETAX"
//           value={totals.pretax}
//           aggregatedData={aggregatedData}
//           store={store}
//         />
//         <SummaryItem
//           label="TOTAL TAX"
//           value={totals.tax}
//           aggregatedData={aggregatedData}
//           store={store}
//         />
//         <SummaryItem
//           label="TOTAL TAX FREE"
//           value={totals.taxFree}
//           aggregatedData={aggregatedData}
//           store={store}
//         />
//         <SummaryItem
//           label="TOTAL DISCOUNT"
//           value={totals.discount}
//           aggregatedData={aggregatedData}
//           store={store}
//         />
//         <SummaryItem
//           label="TOTAL VOID AMOUNT"
//           value={voidTotals.amount}
//           aggregatedData={aggregatedData}
//           store={store}
//         />

//         <h5 className="mt-1" style={{ fontSize: "12px" }}>
//           <span className="fw-bold">TOTAL VOID COUNT:</span>{" "}
//           {aggregatedData && Object.keys(aggregatedData).length > 0
//             ? voidTotals.count
//             : "Processing..."}
//         </h5>
//       </div>
//       <div className="d-flex justify-content-center mb-2 mt-3 ">
//         <Button
//           className="btn me-2"
//           style={{ backgroundColor: "#d0df42" }}
//           onClick={() => exportCSV()}
//         >
//           <i className="fas fa-file-csv me-2"></i>
//           Export CSV
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default ReportSummary;
import { Button } from "nq-component";
import { CURRENCY_FORMATTER } from "../utils/constants";

const SummaryItem = ({ label, value, aggregatedData, store }) => (
  <h5 className="mt-1" style={{ fontSize: "12px" }}>
    <span className="fw-bold">{label}:</span>{" "}
    {aggregatedData && Object.keys(aggregatedData).length > 0
      ? CURRENCY_FORMATTER.format(value)
      : store
      ? "Processing..."
      : CURRENCY_FORMATTER.format(value)}
  </h5>
);

const ReportSummary = ({
  totals,
  voidTotals,
  aggregatedData,
  store,
  exportCSV,
}) => {
  return (
    <div
      className="p-4"
      style={{
        backgroundImage: `url('/green.png')`,
        borderRadius: "0 0 20px 20px",
        height: "325px",
      }}
    >
      <div className="card p-2" style={{ opacity: ".7" }}>
        <SummaryItem
          label="TOTAL NET SALES"
          value={totals.net}
          aggregatedData={aggregatedData}
          store={store}
        />
        <SummaryItem
          label="TOTAL GROSS SALES"
          value={totals.gross}
          aggregatedData={aggregatedData}
          store={store}
        />
        <SummaryItem
          label="TOTAL PRETAX"
          value={totals.pretax}
          aggregatedData={aggregatedData}
          store={store}
        />
        <SummaryItem
          label="TOTAL TAX"
          value={totals.tax}
          aggregatedData={aggregatedData}
          store={store}
        />
        <SummaryItem
          label="TOTAL TAX FREE"
          value={totals.taxFree}
          aggregatedData={aggregatedData}
          store={store}
        />
        <SummaryItem
          label="TOTAL DISCOUNT"
          value={totals.discount}
          aggregatedData={aggregatedData}
          store={store}
        />
        <SummaryItem
          label="TOTAL VOID AMOUNT"
          value={voidTotals.amount}
          aggregatedData={aggregatedData}
          store={store}
        />

        <h5 className="mt-1" style={{ fontSize: "12px" }}>
          <span className="fw-bold">TOTAL VOID COUNT:</span>{" "}
          {aggregatedData && Object.keys(aggregatedData).length > 0
            ? voidTotals.count
            : store
            ? "Processing..."
            : voidTotals.count}
        </h5>
      </div>
      <div className="d-flex justify-content-center mb-2 mt-3 ">
        <Button
          className="btn me-2"
          style={{ backgroundColor: "#d0df42" }}
          onClick={() => exportCSV()}
        >
          <i className="fas fa-file-csv me-2"></i>
          Export CSV
        </Button>
      </div>
    </div>
  );
};

export default ReportSummary;
